import React from 'react';
import {Box, Typography} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './ErrorBanner.scss';
import {t} from 'i18next';

interface ErrorBannerProps {
  message?: string;
  className?: string;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({
  message = t('ai.investigate.questionAndAnswerPanel.errorBanner.title'),
  className = '',
}) => {
  return (
    <Box
      className={`error-banner ${className}`}
      data-testid="investigate-error-banner"
      role="status"
      aria-live="polite"
    >
      <Box className="error-icon">
        <InfoOutlinedIcon fontSize="small" />
      </Box>
      <Typography
        className="error-text typo-text body3_size"
        data-testid="error-banner-message"
      >
        {message}
      </Typography>
    </Box>
  );
};

export default ErrorBanner;
